import React, { useState } from 'react';
import { CreateNewPassword } from '@desquared/wave-components-library';
import { useRouter } from 'next/router';

import { resetPassword } from '@/api/register';
import { OTPIDStore } from '@/store/otpid';
import User from '@/store/user';
import { createTokenCookie } from '@/utils/cookies';
import { updateUser as updateUserInContactPigeon } from '@/utils/contactPigeon';
import { useTranslations } from 'next-intl';
import { CompleteProfileIDStore } from '@/store/completeProfileId';

import styles from './NewPassword.module.css';

export default function NewPassword({ config, logo, type }) {
  const router = useRouter();
  const [password, setPassWord] = useState('');
  const [passwordErrorText, setPasswordErrorText] = useState('');
  const t = useTranslations('common');
  const r = useTranslations('user_credentials');
  const lengthWording = config
    ? `${config.auth.password.format.min}-${config.auth.password.format.max} ${r('validation.characters')}`
    : `8-100 ${r('validation.characters')}`;
  const capitalWording = r('validation.capitals');
  const specialCharWording = r('validation.specials');

  const onPassWordChange = e => {
    setPassWord(e.currentTarget.value);
  };

  const otpInfo = OTPIDStore.getValue();

  const submit = async () => {
    const { data, error } = await resetPassword({ requestId: otpInfo.requestId, otp: otpInfo.otp, password: password });
    if (error) {
      if (error.code === 'AUTH0008') {
        setPasswordErrorText(error.userMessage);
        return;
      }
    } else {
      if (data.status === 'NEED_TO_COMPLETE_PROFILE') {
        User.update({
          completeProfileRequestId: data.completeProfileRequestId,
          loyaltyCards: data.user.loyaltyCards,
          email: data.user.email,
          stat: data.status,
          _id: data.user._id,
        });
        CompleteProfileIDStore.update(data?.completeProfileRequestId);

        router.push('/account-details');
      } else {
        createTokenCookie(data.authToken.token);
        User.update({
          ...data.user,
          authToken: data.authToken.token,
        });
        if (process.env.hasContactPigeon) {
          updateUserInContactPigeon(data.user.email);
        }
        router.push({
          pathname: '/password-success',
        });
      }
    }
  };

  return (
    <div className={styles.container}>
      <CreateNewPassword
        logo={logo}
        logoRedirect={router.locale === router.defaultLocale ? '/' : `/${router.locale}/`}
        titleText={t('new_password.new_password_title')}
        description={t('new_password.fill_password')}
        continueText={t('new_password.continue')}
        passwordPlaceHolderText={t('new_password.type_here')}
        passwordLabel={t('new_password.new_password')}
        supportEmail={process.env.supportEmail}
        assistiveText={t('new_password.assistive_text')}
        passwordConfig={config.auth.password.format}
        lengthWording={lengthWording}
        capitalWording={capitalWording}
        specialCharWording={specialCharWording}
        onPassWordChange={onPassWordChange}
        passwordValue={password}
        passwordErrorText={passwordErrorText ?? passwordErrorText}
        onContinueClick={submit}
        passwordHelperTextType={passwordErrorText ? 'error' : 'helper'}
        classOption={type === 1 || type === 2 ? styles.paddingContainer : styles.noPaddingContainer}
      />
    </div>
  );
}
